import React from 'react'
import { Logo } from '@/components/Logo'
import { Ico, OAuth } from '@/components/icons'
import { useLang } from '@/lib/lang'

const OAuthButtons = ({ stack = false, a }) => (
  <div style={{ display: stack ? "grid" : "grid", gridTemplateColumns: stack ? "1fr" : "1fr 1fr", gap: 8 }}>
    <button className="oauth-btn"><OAuth.google/> {a.continue_google}</button>
    <button className="oauth-btn"><OAuth.apple/> {a.continue_apple}</button>
    <button className="oauth-btn" style={{ gridColumn: stack ? "auto" : "1 / -1" }}>
      <OAuth.phone/> {a.continue_phone}
    </button>
  </div>
)

const AuthBenefit = ({ icon, title, body }) => (
  <div style={{ display: "flex", gap: 12, alignItems: "start" }}>
    <div style={{ width: 32, height: 32, borderRadius: 10, background: "rgba(194,85,45,0.12)", color: "var(--terracotta)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>{icon}</div>
    <div>
      <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 2 }}>{title}</div>
      <div style={{ fontSize: 13, color: "var(--muted)", lineHeight: 1.45 }}>{body}</div>
    </div>
  </div>
)

const SignUpDesktop = () => {
  const { t } = useLang()
  const a = t.acct.auth.common
  const su = t.acct.auth.signup

  return (
    <div style={{ display: "grid", gridTemplateColumns: "1.05fr 1fr", height: "100%", background: "var(--cream)" }}>
      {/* Left — editorial */}
      <div style={{ background: "var(--cocoa-2)", color: "var(--cream)", padding: "48px 56px", display: "flex", flexDirection: "column", justifyContent: "space-between", position: "relative", overflow: "hidden" }} className="grain">
        <div style={{ position: "relative", zIndex: 2 }}>
          <Logo variant="default" size={32} color="var(--cream)" accent="#E68A5C"/>
        </div>
        <div style={{ position: "relative", zIndex: 2 }}>
          <div className="font-mono" style={{ fontSize: 11, color: "#E68A5C", marginBottom: 18, letterSpacing: "0.1em" }}>
            {su.left_eyebrow}
          </div>
          <h1 className="font-display" style={{ fontSize: 56, lineHeight: 0.95, letterSpacing: "-0.035em", margin: "0 0 22px", fontWeight: 600 }}>
            {su.left_title_1}<br/>
            <span className="font-serif" style={{ color: "#E68A5C", fontWeight: 400 }}>{su.left_title_word}</span> {su.left_title_2}
          </h1>
          <p style={{ fontSize: 16, lineHeight: 1.55, color: "rgba(245,239,230,0.78)", maxWidth: 380, margin: "0 0 36px" }}>
            {su.left_blurb}
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 18, maxWidth: 380 }}>
            <AuthBenefit icon={<Ico.check/>} title={su.benefit_book_title} body={su.benefit_book_body}/>
            <AuthBenefit icon={<Ico.doc/>} title={su.benefit_doc_title} body={su.benefit_doc_body}/>
            <AuthBenefit icon={<Ico.bell/>} title={su.benefit_reminders_title} body={su.benefit_reminders_body}/>
          </div>
        </div>
        <div style={{ position: "relative", zIndex: 2, display: "flex", gap: 12, alignItems: "center", paddingTop: 24, borderTop: "1px solid rgba(245,239,230,0.12)" }}>
          <div style={{ display: "flex" }}>
            {["RC","ML","JS","DK"].map((init, i) => (
              <div key={i} style={{ width: 30, height: 30, borderRadius: "50%", background: ["#C2552D","#7A8C6C","#C99A4A","#8B3A1F"][i], color: "var(--cream)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 600, fontSize: 11, marginLeft: i === 0 ? 0 : -8, border: "2px solid var(--cocoa-2)" }}>{init}</div>
            ))}
          </div>
          <div className="font-mono" style={{ fontSize: 11, color: "rgba(245,239,230,0.65)" }}>
            {su.joining_count}
          </div>
        </div>
      </div>

      {/* Right — form */}
      <div style={{ padding: "48px 64px", display: "flex", flexDirection: "column", justifyContent: "center", overflow: "auto" }}>
        <div style={{ maxWidth: 420, width: "100%", margin: "0 auto" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 32 }}>
            <span className="font-mono" style={{ fontSize: 11, color: "var(--muted)", letterSpacing: "0.08em" }}>{su.step_1_of_2}</span>
            <span className="font-mono" style={{ fontSize: 12, color: "var(--muted)" }}>{su.already_member} <a href="#" style={{ color: "var(--terracotta)", fontWeight: 600 }}>{su.sign_in_link}</a></span>
          </div>
          <h2 className="font-display" style={{ fontSize: 36, fontWeight: 600, letterSpacing: "-0.025em", margin: "0 0 8px" }}>
            {su.title}
          </h2>
          <p style={{ fontSize: 14, color: "var(--muted)", margin: "0 0 28px" }}>
            {su.blurb}
          </p>

          <OAuthButtons a={a}/>

          <div style={{ margin: "22px 0" }}><div className="divider-row">{a.or_use_email}</div></div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <div>
              <label className="auth-input-label">{a.first_name}</label>
              <input className="auth-input" defaultValue="Maria"/>
            </div>
            <div>
              <label className="auth-input-label">{a.last_name}</label>
              <input className="auth-input" defaultValue="Lopez"/>
            </div>
            <div style={{ gridColumn: "1 / -1" }}>
              <label className="auth-input-label">{a.email}</label>
              <input className="auth-input" defaultValue="maria@email.com" type="email"/>
            </div>
            <div style={{ gridColumn: "1 / -1" }}>
              <label className="auth-input-label">{a.password}</label>
              <div style={{ position: "relative" }}>
                <input className="auth-input" type="password" defaultValue="••••••••••" style={{ paddingRight: 44 }}/>
                <span style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", color: "var(--muted)", cursor: "pointer" }}><Ico.eye/></span>
              </div>
              <div style={{ display: "flex", gap: 4, marginTop: 8 }}>
                <div style={{ flex: 1, height: 3, borderRadius: 2, background: "var(--sage)" }}/>
                <div style={{ flex: 1, height: 3, borderRadius: 2, background: "var(--sage)" }}/>
                <div style={{ flex: 1, height: 3, borderRadius: 2, background: "var(--sage)" }}/>
                <div style={{ flex: 1, height: 3, borderRadius: 2, background: "var(--line)" }}/>
              </div>
              <div className="font-mono" style={{ fontSize: 10, color: "var(--muted)", marginTop: 6 }}>{su.pw_hint}</div>
            </div>
          </div>

          <label style={{ display: "flex", gap: 10, alignItems: "start", marginTop: 18, fontSize: 13, color: "var(--muted)", cursor: "pointer" }}>
            <div style={{ width: 16, height: 16, borderRadius: 4, background: "var(--terracotta)", color: "var(--cream)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 1 }}><Ico.check width="11" height="11"/></div>
            <span>{su.terms}</span>
          </label>

          <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center", marginTop: 24 }}>
            {su.create_account} <Ico.arrow/>
          </button>

          <p style={{ fontSize: 12, color: "var(--muted)", marginTop: 18, textAlign: "center" }}>
            Bilingual support · Lic. #CGC1532001 · Miami, FL
          </p>
        </div>
      </div>
    </div>
  )
}

export default function SignUpPage() {
  return <SignUpDesktop />
}
